
export default function HeroSection() {
  return (
    <section className="relative min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/683fafea768d9fe10dee087a938044f3.jpg"
          alt="Aerial view of farmland showcasing precision drone agriculture results"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/80 via-emerald-900/50 to-emerald-950/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-16">
        <div className="max-w-2xl">
          <span className="inline-block text-emerald-400 font-bold text-xs tracking-widest uppercase mb-4">
            Case Studies
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-none tracking-wide text-white">
            Real Fields.<br />
            Real Results.
          </h1>
          <p className="text-xl md:text-2xl mb-6 max-w-xl leading-relaxed font-light text-gray-200">
            See how farmers across the region are protecting yield, saving time, and getting more from every acre with precision aerial services.
          </p>
          <p className="text-lg text-gray-300 font-light tracking-wide max-w-lg">
            No hype. Just documented outcomes from real operations.
          </p>
        </div>
      </div>

      {/* Soft gradient bleed into next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-stone-50 to-transparent z-10"></div>
    </section>
  );
}
